import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import { DIVIDENDS_DAY_POPOVER_TEXT } from '../../utils/constants'
import { formatDate } from '../../utils/functions'
import Popover from '../Popover/Popover'

class TodaysDistribution extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const totalDividend =
      this.props.todaysDistribution &&
      get(this.props.todaysDistribution, 'totalDividend')
    const recordDate =
      totalDividend &&
      get(this.props.todaysDistribution, 'recordDateCalendar.date')

    if (!totalDividend || !recordDate) {
      return null
    }

    const popupText = DIVIDENDS_DAY_POPOVER_TEXT.replace(
      '%{value}',
      `$${totalDividend}`
    ).replace('%{date}', formatDate(recordDate))
    return <Popover content={popupText} />
  }
}

TodaysDistribution.propTypes = {
  todaysDistribution: PropTypes.shape({
    recordDateCalendar: PropTypes.shape({
      date: PropTypes.string,
    }),
    totalDividend: PropTypes.number,
  }),
}

export default TodaysDistribution
